export const TEXT_COLOR = '#333333';
export const BACKGROUND_COLOR = '#FDF9EA';
export const TITLE_COLOR = '#00722E';
export const ACCESS_COLOR = '#ECF7F0';
export const BORDER_COLOR = '#306F36';
